export default "__VITE_ASSET__CFJOSVTe__"